import React from "react";
import { Select } from "components/Select";

export const FilterButtons = ({ activeOnly, setActiveOnly, user }) => {
  const getFilterButtonsData = () => ([
    { id: "false", title: "Zobrazit vše" },
    { id: "true", title: "Jen aktivní" },
  ]);

  const handleChange = (e) => {
    const value = e.target.value === "true";
    setActiveOnly(value);
    localStorage.setItem(`activeOnly${user.pk}`, String(value));
  };

  return (
    <Select
      data={getFilterButtonsData()}
      value={String(activeOnly)}
      onChange={handleChange}
      onlyvalid
      withBorder
    />

  );
};
